export const setSignedInStatus = status => (window.localStorage.signedInStatus = JSON.stringify(status))

export const isSignedIn = () => {
  if (window.localStorage.signedInStatus) {
    const isSignedIn = window.localStorage.signedInStatus;
    return isSignedIn ? JSON.parse(isSignedIn) : false
  }
  return false
}
